// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","FilterLinks__link":"cb_a bhe_h bhe_kf bhe_wb bhe_ss bhe_vr bhe_su bhe_sl"};